<template>
  <v-container fluid class="job-descriptions">
    <v-row>
      <v-col>
        <h2 class="mb-10">Job Posts</h2>
        <div v-for="item in userJobPosts" :key="item.id" class="mb-10">
          <v-card class="mx-auto">
            <v-card-text>
              <div>{{ item.company.name }}</div>
              <p class="display-1 text--primary">{{ item.position }}</p>
              <!-- <p>adjective</p> -->
              <div class="text--primary">Status: {{ item.status }}</div>
              <div class="text--primary">
                Applicants: {{ item.applicants.length }}
              </div>

              <div class="text--primary">Address: {{ item.address }}</div>
              <div class="text--primary">
                Experience Level: {{ item.experienceLevel }}
              </div>
              <div class="text--primary">Salary: {{ item.salary }}</div>
            </v-card-text>
            <v-card-actions>
              <router-link :to="`/recruiter/job-post/${item.id}`">
                <v-btn text color="deep-purple accent-4"> View </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  mounted() {
    this.$store.dispatch('FETCH_ALLPOSTS').then(() => {
      this.calculateJobPosts();
    });
  },

  data() {
    return {
      userJobPosts: [],
    };
  },
  computed: {
    ...mapGetters(['jobPost', 'loading', 'getUserData', 'getUserId']),
  },
  methods: {
    calculateJobPosts() {
      const self = this;
      if (this.jobPost.length) {
        this.jobPost.map((job) => {
          job.users.map((user) => {
            if (user.id === this.getUserData.id) {
              console.log('hit');
              self.userJobPosts.push(job);
              return;
            } else {
              return null;
            }
          });
        });
      } else {
        return null;
      }
    },
  },
};
</script>

<style></style>
